import {Typography, withStyles, withTheme} from '@material-ui/core';
import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {findDOMNode} from 'react-dom';
import {Box, Page, ScrollView} from 'react-layout-components';
import {Animated, Easing} from 'react-native-web';
import Waypoint from 'react-waypoint';
import Container from '../common/Container';
import Footer from '../common/Footer';
import Spacing from '../common/Spacing';
import Toolbar from '../common/Toolbar';
import FadeFromDown from '../transitions/FadeFromDown';

class MScrollView extends ScrollView {
    scrollTo = (scrollTop) => {

        const DOMNode = findDOMNode(this)
        const scrollPos = new Animated.Value(DOMNode.scrollTop)

        Animated
            .timing(scrollPos, {
                toValue: scrollTop,
                delay: 800,
                duration: 800,
                easing: Easing.bezier(.8, .2, .2, .8)
            })
            .start()

        scrollPos.addListener(({ value }) => {
            DOMNode.scrollTop = value
        })
    }
}

class Solutions extends React.PureComponent {

    constructor(props) {
        super(props)

        this.state = {
            solutionsVisibility: {}
        }
    }

    componentDidMount() {
        const node = document.getElementById(this.props.match.params.item)
        if (node) {
            const nodeTop = node.offsetTop
            this.refs.scrollElement.scrollTo(nodeTop - 56)
        }
    }

    asyncSetState = (state) =>
        new Promise(a => requestAnimationFrame(() => this.setState({ ...this.state, ...state }, a)))

    doShowSolution = (s) =>
        this.setState({ ...this.state, solutionsVisibility: { ...this.state.solutionsVisibility, [s.key]: true } })

    render() {

        const { classes, theme } = this.props

        return (
            <Page>
                <MScrollView
                    ref="scrollElement"
                    width="100%"
                    height="100%"
                    onScroll={this.handleScroll}>

                    <div className={classes.scrollContainer}>
                        <Toolbar light elevated />

                        <Box column>
                            {
                                SOLUTIONS.map(s => (
                                    <Waypoint
                                        key={s.key}
                                        onEnter={() => this.doShowSolution(s)}
                                        topOffset={-56}
                                        bottomOffset={56}>
                                        <div id={s.key}
                                            className={cn({ [classes.darkSection]: s.dark })}>
                                            <FadeFromDown visible={this.state.solutionsVisibility[s.key]}>
                                                <Container>
                                                    <Box className={classes.content} column center>

                                                        <Spacing large vertical />
                                                        <Spacing large vertical />

                                                        <Box center column width="100%">
                                                            <span
                                                                style={{
                                                                    color: theme.palette.primary.main,
                                                                    fontWeight: '700',
                                                                    fontFamily: 'Montserrat',
                                                                    textAlign: 'center'
                                                                }}>
                                                                {s.title}
                                                            </span>

                                                            <Spacing large vertical />

                                                            <span
                                                                style={{
                                                                    color: theme.palette.grey['700'],
                                                                    textAlign: 'center',
                                                                    fontWeight: '300',
                                                                    fontFamily: 'Montserrat',
                                                                }}>
                                                                {s.description}
                                                            </span>

                                                        </Box>

                                                        <Spacing large vertical />
                                                        <Spacing large vertical />

                                                    </Box>
                                                </Container>
                                            </FadeFromDown>
                                        </div>
                                    </Waypoint>
                                ))
                            }
                        </Box>
                        <Footer />
                    </div>
                </MScrollView>
            </Page>
        )
    }

}

Solutions.propTypes = {
    classes: PropTypes.any,
}

Solutions.defaultProps = {

}

const styles = theme => ({
    scrollContainer: {
        paddingTop: 64,
        minHeight: window.innerHeight - 64 + 16
    },
    content: {
        width: '100%',
    },
    section: {

    },
    darkSection: {
        backgroundColor: theme.palette.primary.main
    }
})

const isPhone = window.innerWidth <= 480
const isMobile = window.innerWidth <= 1024
const deviceWidth = isPhone ? window.innerWidth - 32 : 480

export const SOLUTIONS = [
    {
        key: 'solution-one',
        title: 'Destaque-se nas redes sociais',
        image: '/images/item-01.png',
        shortDescription: <span>Montaremos seus pefis e páginas <br/>preservando a identidade visual <br/>da sua empresa ou produto</span>,
        description: '',
        link: '/solucoes/solution-one'
    },
    {
        key: 'solution-two',
        title: 'Alcance mais pessoas',
        image: '/images/item-02.png',
        shortDescription: <span>Atrairemos mais seguidores, <br/>aumentando o alcance das suas <br/>postagems</span>,
        dark: true,
        link: '/solucoes/apps-e-sites'
    },
    {
        key: 'solution-three',
        title: 'Publique seu conteúdo',
        image: '/images/item-03.png',
        shortDescription: <span>Levaremos sua empresa ou produto para <br/>potenciais clientes com postagens <br/>atraentes e direcionadas</span>,
        description: 'Donec rutrum congue leo eget malesuada. Vestibulum ac diam sit amet quam vehicula elementum sed sit amet dui. Donec sollicitudin molestie malesuada. Mauris blandit aliquet elit, eget tincidunt nibh pulvinar a. Vivamus suscipit tortor eget felis porttitor volutpat. Praesent sapien massa, convallis a pellentesque nec, egestas non nisi. Curabitur aliquet quam id dui posuere blandit. Quisque velit nisi, pretium ut lacinia in, elementum id enim. Curabitur arcu erat, accumsan id imperdiet et, porttitor at sem. Curabitur arcu erat, accumsan id imperdiet et, porttitor at sem. Sed porttitor lectus nibh. Curabitur aliquet quam id dui posuere blandit. Mauris blandit aliquet elit, eget tincidunt nibh pulvinar a.',
        link: '/solucoes/solution-three'
    },
]

export const PLANS = [
    {
        key: 'solution-one',
        title:
            <Box column >
                <Typography variant={'title'} color={'primary'}
                            style={{
                                fontWeight: '700',
                                fontFamily: 'Montserrat',
                                textAlign: 'center'
                            }}>
                    Básico
                </Typography>
                <Spacing vertical/>
                <Typography variant={'title'} color={'primary'}
                            style={{
                                fontWeight: '700',
                                fontFamily: 'Montserrat',
                                textAlign: 'center'
                            }}>
                    <span style={{fontSize: 28, fontWeight: '900'}}>R$ 250</span>/mês
                </Typography>
            </Box>,
        shortDescription: <span>
            - Reformulação das páginas e perfis<br/>
            - Até 3 postagens semanais<br/>
            - Até 2 vídeos mensais<br/>
        </span>,
        description: '',
        link: '/solucoes/solution-one'
    },
    {
        key: 'solution-two',
        title:
            <Box column >
                <Typography variant={'title'} color={'primary'}
                            style={{
                                fontWeight: '700',
                                fontFamily: 'Montserrat',
                                textAlign: 'center'
                            }}>
                    Empresarial
                </Typography>
                <Spacing vertical/>
                <Typography variant={'title'} color={'primary'}
                            style={{
                                fontWeight: '700',
                                fontFamily: 'Montserrat',
                                textAlign: 'center'
                            }}>
                    <span style={{fontSize: 28, fontWeight: '900'}}>R$ 500</span>/mês
                </Typography>
            </Box>,
        shortDescription: <span>
            - Reformulação das páginas e perfis<br/>
            - Até 6 postagens semanais<br/>
            - Até 4 vídeos mensais<br/>
        </span>,
        description: '',
        link: '/solucoes/solution-two'
    },
    {
        key: 'solution-three',
        title:
            <Box column >
                <Typography variant={'title'} color={'primary'}
                            style={{
                                fontWeight: '700',
                                fontFamily: 'Montserrat',
                                textAlign: 'center'
                            }}>
                    Customizado
                </Typography>
                <Spacing vertical/>
                <Typography variant={'title'} color={'primary'}
                            style={{
                                fontWeight: '700',
                                fontFamily: 'Montserrat',
                                textAlign: 'center'
                            }}>
                    <span style={{fontSize: 28, fontWeight: '900'}}>
                        Fale conosco!
                    </span>
                </Typography>
            </Box>,
        shortDescription: <span>
            Obtenha um plano totalmente<br/>
            customizado de acordo com as <br/>
            necessidades da sua empresa<br/>
        </span>,
        description: '',
        link: '/solucoes/solution-one'
    },
]

export default withTheme()(withStyles(styles)(Solutions))


// WEBPACK FOOTER //
// ./src/components/pages/Solutions.js